export default __webpack_public_path__ + "static/media/online-shopping.8f2cc56f.png";